const outlineBase = {
  border: 'medium',
  borderRadius: 'button',
  h: '9',
  minWidth: '20',
  fontSize: 'sm',
};

export default {
  Button: {
    baseStyle: {
      _focus: {
        boxShadow: 'none',
      },
    },
    variants: {
      default: {
        textStyle: 'button',
        border: 'medium',
        borderColor: 'primary.base',
        borderRadius: 'button',
        bgColor: 'primary.base',
        color: 'white',
        h: '9',
        minWidth: '20',
        fontSize: 'sm',
        _hover: {
          bgColor: 'white',
          color: 'text.base',
          borderColor: 'primary.base',
        },
      },
      outline: {
        ...outlineBase,
        bgColor: 'white',
        borderRadius: 'button',
        borderColor: 'primary.base',
        _hover: {
          bgColor: 'primary.base',
          color: 'white',
        },
      },
      outlineGray: {
        ...outlineBase,
        bgColor: 'border.light',
        borderRadius: 'button',
        borderColor: 'border.base',
        _hover: {
          bgColor: 'border.base',
          color: 'white',
        },
      },
      outlineRound: {
        border: 'medium',
        borderRadius: 'button',
        isRound: true,
        bgColor: 'white',
        borderColor: 'primary.base',
        _hover: {
          bgColor: 'primary.base',
          color: 'white',
        },
      },
      outlinePrimaryRound: {
        border: 'medium',
        borderRadius: 'button',
        isRound: true,
        bgColor: 'white',
        borderColor: 'primary.base',
        _hover: {
          bgColor: 'white',
          borderColor: 'primary.light',
        },
        _active: {
          bgColor: 'white',
          borderColor: 'primary.dark',
        },
      },
      primaryOutline: {
        ...outlineBase,
        borderRadius: 'button',
        borderColor: 'primary.base',
        _hover: {
          borderColor: 'primary.light',
        },
        _active: {
          borderColor: 'primary.dark',
        },
      },
      primary: {
        ...outlineBase,
        bgColor: 'primary.base',
        borderColor: 'primary.base',
        color: 'white',
        _hover: {
          bgColor: 'primary.light',
          borderColor: 'primary.light',
        },
        _active: {
          bgColor: 'primary.dark',
          borderColor: 'primary.dark',
        },
      },
      secondaryOutlineGray: {
        ...outlineBase,
        borderColor: 'border.base',
        _hover: {
          borderColor: 'secondaryButton.hover',
        },
        _active: {
          borderColor: 'secondaryButton.down',
        },
      },
      link: {
        color: 'primary.base',
        fontSize: 'sm',
        lineHeight: '1',
        _hover: {
          textDecoration: 'none',
        },
      },
      dropdownMenuButton: {
        bgColor: 'white',
        border: 'light',
        borderColor: 'gray.300',
        _hover: {
          bgColor: 'white',
        },
      },
      pagination: {
        fontSize: 'sm',
      },
    },
    defaultProps: {
      variant: 'default',
    },
  },
};
